'use strict'
const SemVerLt = require('semver/functions/lt')
let maxVersionForEventsPage = '3.13.0'
const minAI14VersionForEventsPage = '14.2.0'
const SemVerGte = require('semver/functions/gte')
const SemverSatifies = require('semver/functions/satisfies')
const deviceEventSettings = window.filterEnvironmentDeviceSettings(
  require('cloud-utils/config/events/default.json').deviceEventSettings
)
const _ = require('lodash')
angular
  .module('surfsightApp.controllers')
  .controller('organizationEventsSettingsEditController', [
    '$scope',
    '$mdDialog',
    '$rootScope',
    '$mdColors',
    'SystemConstants',
    'UnitSystem',
    '$localStorage',
    '$timeout',
    '$filter',
    '$mdToast',
    function (
      $scope,
      $mdDialog,
      $rootScope,
      $mdColors,
      SystemConstants,
      UnitSystem,
      $localStorage,
      $timeout,
      $filter,
      $mdToast
    ) {
      const $translate = $filter('translate')
      $scope.UnitSystem = UnitSystem
      if ($localStorage.measurementUnits === 1) {
        SystemConstants.unit = 1
      } else {
        SystemConstants.unit = 0
      }
      $scope.themePrimary = $mdColors.getThemeColor('primary')
      $scope.themeAccent = $mdColors.getThemeColor('accent')
      maxVersionForEventsPage =
        $rootScope.organizationSettings.maxVersionForEventsPage &&
        SemVerGte(
          $rootScope.organizationSettings.maxVersionForEventsPage,
          maxVersionForEventsPage
        )
          ? $rootScope.organizationSettings.maxVersionForEventsPage
          : maxVersionForEventsPage
      const camelCaseConfig = config => {
        const newConfig = angular.copy(config)
        Object.keys(config).forEach(key => {
          const camelCaseKey = _.camelCase(key)
          if (camelCaseKey !== key) {
            newConfig[_.camelCase(key)] = newConfig[key]
            delete newConfig[key]
          }
        })
        return newConfig
      }
      $scope.available_edge_event_settings = deviceEventSettings
        .filter(
          e =>
            (!e.fromVersion ||
              SemVerLt(e.fromVersion, maxVersionForEventsPage) ||
              SemVerGte(e.fromVersion, minAI14VersionForEventsPage)) &&
            (!e.configure ||
              e.configure.allowInOrganizationSettingUI === undefined ||
              e.configure.allowInOrganizationSettingUI) &&
            (e.name !== 'yawn' ||
              $rootScope.organizationSettings
                .isYawnEvFeatureEnabledForPartnerOfOrganization)
        )
        .map(setting => ({
          ...setting,
          ...(setting.defaultConfiguration && {
            config: camelCaseConfig(setting.defaultConfiguration)
          })
        }))
      const eventsSettings =
        $rootScope.organizationSettings.organizationEventsSetting
      const triggers = [...eventsSettings.events]
      $scope.isBulkDeviceSelection = true
      $scope.proxyStatus = true

      $scope.carTypes = [
        {
          id: 'Private',
          name: 'private'
        },
        {
          id: 'Van',
          name: 'van'
        },
        {
          id: 'Trailer',
          name: 'trailer'
        }
      ]
      $scope.vehicleType = {
        value: eventsSettings.vehicleType
      }
      $scope.available_edge_event_settings.forEach(function (event, i) {
        $scope.available_edge_event_settings[i].index = i
        $scope.available_edge_event_settings[i].status = 'off'
        $scope.available_edge_event_settings[i].isVisualAlertAvailable =
          event.name !== 'fatigue' &&
          !!$scope.available_edge_event_settings[i].visualAlert &&
          (!window.MAX_SUPPORTED_DEVICE_VERSION ||
            SemVerGte(
              window.MAX_SUPPORTED_DEVICE_VERSION,
              $scope.available_edge_event_settings[i].visualAlert.fromVersion
            ))
        $scope.available_edge_event_settings[i].isAudioAlertAvailable =
          event.name !== 'fatigue' &&
          !!$scope.available_edge_event_settings[i].audioAlert &&
          (!window.MAX_SUPPORTED_DEVICE_VERSION ||
            SemVerGte(
              window.MAX_SUPPORTED_DEVICE_VERSION,
              $scope.available_edge_event_settings[i].audioAlert.fromVersion
            ))
        $scope.available_edge_event_settings[i].eventSettingsSupported = ![
          'geoFence',
          'virtualEvent',
          'accOff',
          'accOn'
        ].includes($scope.available_edge_event_settings[i].v2Name)
        if (
          $scope.available_edge_event_settings[i].v2Name === 'possibleFatigue'
        ) {
          $scope.available_edge_event_settings[i].drivingDuration =
            $scope.available_edge_event_settings[i].config.drivingDuration
        }
        const trigger = triggers.find(t => t.eventType === event.v2Name)
        if (trigger) {
          $scope.available_edge_event_settings[i].status =
            trigger.dataType || 'off'
          if ($scope.available_edge_event_settings[i].isVisualAlertAvailable) {
            $scope.available_edge_event_settings[i].visualAlert.value =
              trigger.visualAlert || false
          }
          if ($scope.available_edge_event_settings[i].isAudioAlertAvailable) {
            $scope.available_edge_event_settings[i].audioAlert.value =
              trigger.audioAlert || false
          }

          $scope.available_edge_event_settings[i].isNumberOfBeepsAvailable =
            !!$scope.available_edge_event_settings[i].numberOfBeeps &&
            $scope.available_edge_event_settings[i].status !== 'off'
          $scope.available_edge_event_settings[i].isMinimumSpeedAvailable =
            !!$scope.available_edge_event_settings[i].minimumSpeed &&
            $scope.available_edge_event_settings[i].status !== 'off'
          if (
            $scope.available_edge_event_settings[i].isNumberOfBeepsAvailable
          ) {
            $scope.available_edge_event_settings[i].numberOfBeeps.value =
              trigger.numberOfBeeps !== undefined
                ? trigger.numberOfBeeps
                : $scope.available_edge_event_settings[i].numberOfBeeps
                    .defaultValue
            const {
              allowedValueRange,
              incrementBy
            } = $scope.available_edge_event_settings[i].numberOfBeeps
            const allowedValues = window.getRange(
              allowedValueRange[0],
              allowedValueRange[1],
              incrementBy
            )
            $scope.available_edge_event_settings[
              i
            ].numberOfBeeps.allowedValues = allowedValues
          }
          if ($scope.available_edge_event_settings[i].isMinimumSpeedAvailable) {
            const minSpeedValue =
              trigger.minimumSpeed !== undefined
                ? trigger.minimumSpeed
                : $scope.available_edge_event_settings[i].minimumSpeed
                    .defaultValue

            $scope.available_edge_event_settings[
              i
            ].minimumSpeed.value = Math.ceil(
              UnitSystem.value(parseInt(minSpeedValue), 'km/h', '$v')
            )

            const { allowedValueRange } = $scope.available_edge_event_settings[
              i
            ].minimumSpeed
            $scope.available_edge_event_settings[i].minimumSpeed.minValue =
              allowedValueRange[0]
            $scope.available_edge_event_settings[i].minimumSpeed.maxValue =
              allowedValueRange[1]
          }
          if (event.isSpeedLimit) {
            $scope.available_edge_event_settings[i].speedLimit = Math.ceil(
              UnitSystem.value(parseInt(trigger.speedLimit), 'km/h', '$v')
            )
          }
          if (event.isPossibleFatigue) {
            $scope.available_edge_event_settings[i].drivingDuration = parseInt(
              trigger.drivingDuration
            )
          }
          if (trigger.config) {
            $scope.available_edge_event_settings[i].config = trigger.config
          }
        }
      })
      $scope.event_settings = [...$scope.available_edge_event_settings]
      $scope.cancel = () => {
        $mdDialog.cancel()
      }
      $scope.onChangeDataType = edgeSettings => {
        if (edgeSettings.status === 'off') {
          if (edgeSettings.isSpeedLimit) {
            edgeSettings.speedLimit = -1
          }
          if (edgeSettings.isVisualAlertAvailable) {
            edgeSettings.visualAlert.value = false
          }
          if (edgeSettings.isAudioAlertAvailable) {
            edgeSettings.audioAlert.value = false
          }
          if (edgeSettings.isNumberOfBeepsAvailable) {
            edgeSettings.isNumberOfBeepsAvailable = false
          }
          if (edgeSettings.isMinimumSpeedAvailable) {
            edgeSettings.isMinimumSpeedAvailable = false
          }
        } else {
          // show number of beeps drop down when event status is not set to off
          if (edgeSettings.numberOfBeeps) {
            const {
              allowedValueRange,
              incrementBy
            } = edgeSettings.numberOfBeeps
            const allowedValues = window.getRange(
              allowedValueRange[0],
              allowedValueRange[1],
              incrementBy
            )
            edgeSettings.numberOfBeeps.allowedValues = allowedValues
            edgeSettings.numberOfBeeps.value =
              edgeSettings.numberOfBeeps.value ||
              edgeSettings.numberOfBeeps.defaultValue
            edgeSettings.isNumberOfBeepsAvailable = true
          }

          // show min speed drop down when event status is not set to off
          if (edgeSettings.minimumSpeed) {
            const { allowedValueRange } = edgeSettings.minimumSpeed
            edgeSettings.minimumSpeed.minValue = allowedValueRange[0]
            edgeSettings.minimumSpeed.maxValue = allowedValueRange[1]
            edgeSettings.minimumSpeed.value =
              edgeSettings.minimumSpeed.value ||
              edgeSettings.minimumSpeed.defaultValue
            edgeSettings.isMinimumSpeedAvailable = true
          }
        }
      }
      $scope.saveEventsSettings = () => {
        let error = false
        const data = {
          vehicleType: $scope.vehicleType.value,
          events: $scope.available_edge_event_settings.map(event => {
            const { speedLimit, drivingDuration } = event
            const config = event.config
            const obj = {
              eventType: event.v2Name,
              dataType: event.status,
              weight: event.score || 0
            }
            if (config) {
              if ('drivingDuration' in config) {
                delete config.drivingDuration
              }
              obj.config = config
              if (event.name === 'possibleFatigue') {
                delete obj.config
              }
            }
            if (speedLimit) {
              obj.speedLimit =
                Math.ceil(speedLimit) *
                ($localStorage.measurementUnits === 1 ? 1.609 : 1)
            }
            if (drivingDuration !== undefined && drivingDuration !== null) {
              obj.drivingDuration = drivingDuration
            }
            if (event.audioAlert && event.name !== 'fatigue') {
              obj.audioAlert = event.audioAlert.value || false
            }
            if (event.visualAlert && event.name !== 'fatigue') {
              obj.visualAlert = event.visualAlert.value || false
            }
            if (event.numberOfBeeps) {
              obj.numberOfBeeps =
                event.numberOfBeeps.value !== undefined
                  ? event.numberOfBeeps.value
                  : event.numberOfBeeps.defaultValue
            }
            if (event.minimumSpeed && event.status !== 'off') {
              const minimumSpeedValue = +event.minimumSpeed.value
              if (
                !Number.isInteger(minimumSpeedValue) ||
                !(minimumSpeedValue >= 0 && minimumSpeedValue <= 180)
              ) {
                error = error || true
                const invalidMinSpeedErrorMessage = $translate(
                  'minSpeedEventSettingValidationError'
                )
                const eventSettingName = $translate(event.translate_name)
                const formatedInvalidMinSpeedErrorMessage = window.messageFormatter(
                  invalidMinSpeedErrorMessage,
                  [eventSettingName]
                )
                return showMessageToast(formatedInvalidMinSpeedErrorMessage)
              }
              obj.minimumSpeed =
                event.minimumSpeed.value !== undefined
                  ? Math.floor(
                      Math.ceil(event.minimumSpeed.value) *
                        ($localStorage.measurementUnits === 1 ? 1.609 : 1)
                    )
                  : Math.floor(
                      Math.ceil(event.minimumSpeed.defaultValue) *
                        ($localStorage.measurementUnits === 1 ? 1.609 : 1)
                    )
            }
            return obj
          })
        }
        if (!error) {
          delete $scope.available_edge_event_settings
          $mdDialog.hide(data)
        }
      }
      $scope.cancelEventSettings = () => {
        $mdDialog.cancel()
      }
      $scope.isRestrictedUser =
        $localStorage.userDetails.accessLevel === 'viewer'

      const showMessageToast = function (message) {
        const toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .actionKey('F1')
          .position('bottom')
          .parent('#edge-event-setting-container')
          .hideDelay(5000)

        $mdToast
          .show(toast)
          .then(function (response) {})
          .catch(() => {})
      }
    }
  ])
